import { render, staticRenderFns } from "./pointTable.vue?vue&type=template&id=6569cd09&scoped=true&"
import script from "./pointTable.vue?vue&type=script&lang=js&"
export * from "./pointTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569cd09",
  null
  
)

export default component.exports